import type React from 'react';
import { Breadcrumbs } from '@itandi/itandi-bb-ui';
import Link from 'next/link';
import { VendorLayoutV2 } from '~/components/common/layouts/VendorLayoutV2';
import { VendorSettingLayout } from '~/components/common/layouts/settings/VendorSettingLayout';
import SettingStyles from '../../SettingStyle.module.scss';
import { PATH as SETTING } from '~/pages/vendors/settings';
import { PATH as INDEX } from '~/pages/vendors/settings/surveys/index';
import { SurveyForm } from '~/components/specifics/vendors/settings/surveys/form/SurveyForm';

export const Page: React.FC = () => (
  <VendorLayoutV2>
    <VendorSettingLayout>
      <div className={SettingStyles.PcBreadcrumbsWrapper}>
        <Breadcrumbs
          items={[
            { label: 'アンケート設定', as: Link, href: INDEX },
            { label: '新規作成' }
          ]}
        />
      </div>
      <div className={SettingStyles.SpBreadcrumbsWrapper}>
        <Breadcrumbs
          items={[
            { label: '設定一覧', as: Link, href: SETTING },
            { label: 'アンケート設定', as: Link, href: INDEX },
            { label: '新規作成' }
          ]}
        />
      </div>
      <SurveyForm />
    </VendorSettingLayout>
  </VendorLayoutV2>
);
